import styled from 'styled-components'

import Input from '../../../components/Form/Input'

export const StyledInput = styled(Input)`
  height: 100%;
  border-bottom: none;
  padding: 0;
  padding-left: 4rem;
  font-size: 1.25rem;

  &:focus {
    &::placeholder {
      opacity: 0;
    }
  }
`
